module.exports = __webpack_public_path__ + "static/media/time.d4c68c6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/time.svg
// module id = 1051
// module chunks = 3